import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../views/Home";
import Monitoring from "../views/Monitoring";
import Digitalization from "../views/Digitalization";
import Memberships from "../views/Memberships";
import Errors from "../views/Errors";
import NewAgreement from '../views/NewAgreement'
import Customers from '../views/Customers';
import Warnings from "@/views/Warnings";
import Shops from "../views/Shops.vue";
import Devices from "@/views/Devices";
import SenseiAnagraphic from "@/views/SenseiAnagraphic.vue";
import SenseiCharges from "@/views/SenseiCharges.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
   // redirect: '/memberships',
    children: [
      {
        path: 'memberships',
        name: 'Memberships',
        component: Memberships
      },
      {
        path: 'monitor',
        name: 'Monitoring',
        component: Monitoring
      },
      {
        path: 'errors',
        name: 'Errors',
        component: Errors
      },
      {
        path: 'digitalization',
        name: 'Digitalization',
        component: Digitalization
      },
      {
        path: 'new-agreement',
        name: 'NewAgreement',
        component: NewAgreement
      },
      {
        path: 'customers',
        name: 'Customers',
        component: Customers
      },
      {
        path: 'warnings',
        name: 'Warnings',
        component: Warnings
      },
      {
        path: 'shops',
        name: 'Shops',
        component: Shops
      },
      {
        path: 'devices',
        name: 'Devices',
        component: Devices
      },
      {
        path: 'sensei_anagraphic',
        name: 'SenseiAnagraphic',
        component: SenseiAnagraphic
      },
      {
        path: 'sensei_charges',
        name: 'SenseiCharges',
        component: SenseiCharges
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

const routesV2 = ['/memberships', '/customers', '/digitalization', '/warnings']

router.beforeEach((to, from, next) => {

  const isV2Route = routesV2.some(prefix => to.path.startsWith(prefix))
  if (isV2Route) {
    window.location.href = to.fullPath
  } else {
    next()
  }
})

export default router
